import { render, staticRenderFns } from "./FrameFooter.vue?vue&type=template&id=feaf5526&"
var script = {}
import style0 from "./FrameFooter.vue?vue&type=style&index=0&id=feaf5526&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports